import { Moment } from 'moment-timezone';

const adjustDateForView = (date: Moment, timezone: string) => {
	const dateClone = date.clone().tz(timezone);
	return dateClone.subtract(Number(dateClone.isDST()), 'hour');
};

const adjustDateForServer = (date: Moment, timezone: string) => {
	const dateClone = date.clone().tz(timezone);
	return dateClone.add(Number(dateClone.isDST()), 'hour').utc();
};

export const dstManager = {
	adjustDateForView,
	adjustDateForServer
};
